import React from 'react';
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

import { FlexColumn } from 'src/components/flex';
import { useConversationsPageContext } from 'src/pages/landlord/conversations/context';
import Category from 'src/pages/landlord/conversations/components/list/ConversationsListCategory';
import NoSearchResults from 'src/pages/landlord/conversations/components/list/ConversationsNoSearchResults';

const ConversationsList = () => {
    const {
        isSearchOrFilterActive,
        filteredConversations,
        categories,
        search: searchQuery,
        filter: searchFilter,
    } = useConversationsPageContext();
    const navigate = useNavigate();

    const isSearchingWithoutResults = isSearchOrFilterActive && filteredConversations !== undefined && filteredConversations.length === 0;

    return (
        <FlexColumn gap={2} py={3} alignItems="center">
            {!isSearchingWithoutResults && categories.map((cat) => (
                <Category key={cat} category={cat} />
            ))}

            {isSearchingWithoutResults && (
                <NoSearchResults />
            )}

            {/* only show button if the user is searching */}
            {isSearchOrFilterActive && (
                <Button
                    role="link"
                    variant="contained"
                    onClick={() => {
                        const params = new URLSearchParams();
                        if (searchFilter) {
                            for (const [key, value] of Object.entries(searchFilter)) {
                                if (value && !(Array.isArray(value) && value.length === 0)) {
                                    params.append(key, String(value));
                                }
                            }
                        }
                        if (searchQuery) {
                            params.append('q', searchQuery || '');
                        }
                        const path = '/landlord/inner/archive?' + params.toString();

                        navigate(path);
                    }}
                    startIcon={<ArchiveIcon />}
                    data-testid="search-archived-btn"
                >
                    Search In Archive
                </Button>
            )}
        </FlexColumn >
    );
};

export default ConversationsList;
